import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { formatAmount, formatLargePrice } from "../../shared";

// props
interface IProps {
	total: { count: number; value: number };
	distribution: { count: number; value: number };
	emoji: string;
	title: string;
	usd: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HolderDistributionRow',
  props: {
    total: null,
    distribution: null,
    emoji: null,
    title: null,
    usd: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	total: { count: number; value: number };
	distribution: { count: number; value: number };
	emoji: string;
	title: string;
	usd: boolean;
};



const percentage = computed<number>(() => {
	if (props.usd) {
		return (props.distribution.value / props.total.value) * 100 || 0;
	}

	return (props.distribution.count / props.total.count) * 100 || 0;
});
const totalAmount = computed<number>(() => {
	if (props.usd) {
		return props.distribution.value;
	}

	return props.distribution.count;
});

return { __sfc: true,props, percentage, totalAmount, formatAmount, formatLargePrice }
}

})